import classNames from "classnames";

import {KM_OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {DOT_SIZE_REM, getGalleryDotStyles} from "../../utils/get_gallery_dot_style";

import * as styles from "./GalleryDotsPagination.module.css";

interface IProps {
    activeIndex: number;
    slidesCount: number;
    className?: string;
}

export const GalleryDotsPagination = (props: IProps) => {
    const {activeIndex, className, slidesCount} = props;
    const dots = getGalleryDotStyles(activeIndex, slidesCount);

    if (dots.length === 0) return null;

    return (
        <div
            aria-hidden
            className={classNames(styles.dotsHolder, className)}
            data-testid={KM_OFFER_TEST_IDS.GALLERY_DOTS}
            style={{gridAutoColumns: `${DOT_SIZE_REM.ACTIVE}rem`}}
        >
            {dots.map((dot) => (
                <span
                    className={classNames(styles.dot, dot.isActive ? styles.activeDot : styles.inactiveDot)}
                    data-testid={dot.isActive ? KM_OFFER_TEST_IDS.GALLERY_DOT_ACTIVE : KM_OFFER_TEST_IDS.GALLERY_DOT}
                    key={dot.index}
                    style={{
                        height: `${dot.sizeRem}rem`,
                        width: `${dot.sizeRem}rem`
                    }}
                />
            ))}
        </div>
    );
};
import classNames from "classnames";

import {KM_OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {DOT_SIZE_REM, getGalleryDotStyles} from "../../utils/get_gallery_dot_style";

import * as styles from "./GalleryDotsPagination.module.css";

interface IProps {
    activeIndex: number;
    slidesCount: number;
    className?: string;
}

export const GalleryDotsPagination = (props: IProps) => {
    const {activeIndex, className, slidesCount} = props;
    const dots = getGalleryDotStyles(activeIndex, slidesCount);

    if (dots.length === 0) return null;

    return (
        <div
            aria-hidden
            className={classNames(styles.dotsHolder, className)}
            data-testid={KM_OFFER_TEST_IDS.GALLERY_DOTS}
            style={{gridAutoColumns: `${DOT_SIZE_REM.ACTIVE}rem`}}
        >
            {dots.map((dot) => (
                <span
                    className={classNames(styles.dot, dot.isActive ? styles.activeDot : styles.inactiveDot)}
                    data-testid={dot.isActive ? KM_OFFER_TEST_IDS.GALLERY_DOT_ACTIVE : KM_OFFER_TEST_IDS.GALLERY_DOT}
                    key={dot.index}
                    style={{
                        height: `${dot.sizeRem}rem`,
                        width: `${dot.sizeRem}rem`
                    }}
                />
            ))}
        </div>
    );
};
